import classNames from 'classnames'
import {Text} from 'quickstart/components/content/Text'
import {dataProps, withProps} from 'quickstart/theme'
import type {ComponentProps} from 'react'
import * as S from './styles'
import C from './styles.module.css'

interface CardProps extends ComponentProps<'div'> {
  as?: any
  stretch?: boolean
  clickable?: boolean
}

const _Card = ({as = 'div', clickable, stretch, ...props}: CardProps) => {
  const AsComponent = as as 'div'
  return (
    <AsComponent
      {...dataProps({clickable, stretch})}
      {...props}
      className={classNames(C.card, props.className)}
    />
  )
}

export const Card = Object.assign(_Card, {
  Cover: S.Cover,
  Body: S.Body,
  Footer: S.Footer,
  Meta: S.Meta,
  Heading: S.Heading,
  Description: withProps({variant: 'cardSnippet'})(Text),
  CallToAction: S.CallToAction,
})
